<template>
    <div>

        <!-- heading -->
        <UnderlinedHeading :route="route" :linkText="linkText" class="ph3 ph4-ns mb3 mb4-ns">{{tool.title}}</UnderlinedHeading>

        <div class="ph3 ph4-ns">
            <!-- category hierachy -->
            <CategoryLevels :categoryLevels="tool.categoryLevels"/>

            <!-- tool images and description -->
            <ToolPreviewShell :tool="tool" :imageIndex="imageIndex" class="mt3">
                <ImageStrip :images="tool.images" @select="imageIndex = $event" />
            </ToolPreviewShell>
        </div>

    </div>
</template>

<script>
import UnderlinedHeading from '@/components/controls/UnderlinedHeading.vue';
import CategoryLevels from '@/components/global/displayToolCore/CategoryLevels.vue';
import ToolPreviewShell from '@/components/global/ToolPreviewShell.vue';
import ImageStrip from '@/components/global/displayToolCore/ImageStrip.vue';

export default {
    data: function() {
        return {
            imageIndex: 0
        };
    },
    components: {
        UnderlinedHeading,
        CategoryLevels,
        ToolPreviewShell,
        ImageStrip
    },
    props: {
        tool: {
            type: Object
        },
        route: {
            type: String
        },
        linkText: {
            type: String
        }
    }
};
</script>
